import { dayjs } from 'lib/dayjs';
import { Path, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const UpdatedBy = <TData extends { owner_mail: string; updated_at: string }>() => {
  const { t } = useTranslation();
  const { getValues } = useFormContext<TData>();
  const [owner_mail, updated_at] = getValues(['owner_mail', 'updated_at'] as Path<TData>[]) || [];
  const username = owner_mail?.split('@')[0] || '';
  const updatedAt = dayjs(updated_at)
    .utc()
    .format(t('components:date_filter.date.datetime_minute'));
  return (
    <span className="action-details-footer-last-edition-by">
      {updatedAt && username && t('case:last_edition_by', { updatedAt, username })}
    </span>
  );
};
